var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import useAuth from './useAuth';
import { followTour, getTourFollow, unfollowTour } from '../common/network/tour';
export const useTourFollow = (tourId) => {
    const [auth] = useAuth();
    const [following, setFollowing] = useState(null);
    useEffect(() => {
        let isCurrent = true;
        setFollowing(null);
        if (auth.isAuthenticated) {
            getTourFollow(tourId)
                .then(x => { if (isCurrent)
                setFollowing(x.following); })
                .catch(() => { if (isCurrent)
                setFollowing(false); });
        }
        return () => { isCurrent = false; };
    }, [auth.isAuthenticated, tourId]);
    const status = !auth.isAuthenticated ? 'signed-out'
        : following === null ? 'loading'
            : following ? 'on'
                : 'off';
    const turnOn = () => __awaiter(void 0, void 0, void 0, function* () { return setFollowing((yield followTour(tourId)).following); });
    const turnOff = () => __awaiter(void 0, void 0, void 0, function* () { return setFollowing((yield unfollowTour(tourId)).following); });
    return { status, turnOn, turnOff };
};
